import React from 'react';
import {
  Flex,
  Stack,
  Heading,
  Column,
  Row,
} from '@grubhubprod/gh-cookbook-react';
import { useBalanceContext } from 'src/components/selfService/common/Balance/hooks/useBalanceContext';
import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import { getBalanceCreditLimitStatus } from 'src/components/selfService/common/Balance/utils/getBalanceCreditLimitStatus/getBalanceCreditLimitStatus';
import { getUsagePercent } from 'src/common/utils/getUsagePercent';
import { getCreditProgressBadge } from 'src/components/selfService/common/Balance/sections/BalanceCreditProgressSection/creditProgressBadge.utils';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { CreditAvailabilityBadge } from 'src/components/selfService/common/Balance/sections/BalanceCreditProgressSection/CreditAvailabilityBadge';
import { CreditProgressBar } from 'src/components/selfService/common/Balance/components/CreditProgressBar/CreditProgressBar';

export function BalanceCreditProgressSectionBody(): JSX.Element {
  const { creditInfo } = useBalanceContext();
  const { isPhone } = useScreenSizes();

  if (
    !creditInfo ||
    typeof creditInfo.creditLimit !== 'number' ||
    typeof creditInfo.availableCredit !== 'number'
  ) {
    return null;
  }

  const usedCreditInPennies =
    creditInfo.creditLimit - creditInfo.availableCredit;
  const creditProgressStatus = getBalanceCreditLimitStatus(creditInfo);
  const percentageUsed = getUsagePercent(
    usedCreditInPennies,
    creditInfo.creditLimit
  );
  const creditProgressStatusContent = getCreditProgressBadge(
    creditProgressStatus,
    creditInfo.availableCredit
  );

  return (
    <Flex flexDirection="column" style={{ gap: '8px' }}>
      <Row alignItems="center">
        {isPhone && (
          <Column phone={12}>
            <Stack y="sm">
              <CreditAvailabilityBadge
                creditProgressStatusContent={creditProgressStatusContent}
              />
            </Stack>
          </Column>
        )}
        <Column phone={12} tablet={6}>
          <Flex flexDirection="column" style={{ gap: '4px' }}>
            <Heading variant="h5" color="secondaryText">
              Credit usage
            </Heading>
            <Heading variant="h6">
              {`${formatPenniesToCurrency(
                usedCreditInPennies
              )} / ${formatPenniesToCurrency(creditInfo.creditLimit)}`}
            </Heading>
          </Flex>
        </Column>
        {!isPhone && (
          <Column tablet={6}>
            <CreditAvailabilityBadge
              creditProgressStatusContent={creditProgressStatusContent}
            />
          </Column>
        )}
      </Row>
      <Row>
        <Column phone={12}>
          <CreditProgressBar progress={percentageUsed} />
        </Column>
      </Row>
      <Row alignItems="center">
        <Column phone={12}>
          <Flex justifyContent="flex-end">
            <Heading variant="h6">{`${percentageUsed}% used`}</Heading>
          </Flex>
        </Column>
      </Row>
    </Flex>
  );
}
